type TruncateParams = { size: number; indicator: string };
export const truncate =
  ({ size, indicator }: TruncateParams) =>
  (text: string): string =>
    text.length <= size ? text : `${text.slice(0, size - indicator.length)}${indicator}`;

export const isString = (value: unknown): value is string => typeof value === 'string';

export const classNames = (...classes: unknown[]): string => classes.filter(Boolean).join(' ');
